import type { CreditV1PeriodProduct, PaidTrialInfo } from '@/app/types';

/**
 * 从订阅产品列表中取出付费试用档信息，没有配置试用时返回 null。
 *
 * `paid_trial` 由后端仅对符合资格的用户、且配置了试用的 Stripe 月付订阅下发，
 * 因此"该字段存在"本身就是"当前用户能看到试用 tab"的判据。
 * 订阅页据此插入试用 tab，开屏弹窗据此决定是否展示试用引导 —— 两处必须同源，
 * 否则会出现弹窗承诺试用、落地页却没有试用 tab 的错配。
 */
export const getPaidTrialInfo = (subscriptionProducts: CreditV1PeriodProduct[]): PaidTrialInfo | null => {
  for (const product of subscriptionProducts) {
    const paidTrial = product.paid_trial;
    if (paidTrial?.price !== undefined && paidTrial.duration_days) {
      return {
        price: paidTrial.price,
        duration_days: paidTrial.duration_days,
        regular_price: product.price ?? 0,
        currency: product.currency ?? 'USD',
      };
    }
  }
  return null;
};
